import React, { useState, useEffect } from 'react';
import jwt from 'jwt-simple';

const OnboardingFlow = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState({});

  // Remove watermark after component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        // Simple watermark removal
        const watermarks = document.querySelectorAll('[style*="position: fixed"]');
        watermarks.forEach(el => {
          if (el.textContent && el.textContent.toLowerCase().includes('emergent')) {
            el.style.display = 'none';
          }
        });
      } catch (e) {
        console.log('Watermark removal error:', e);
      }
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const steps = [
    {
      id: 1,
      title: "DIRTY GAMES",
      subtitle: "Before you play, we need to ask you a couple of questions.",
      question: "Is your door locked and are you ready to cum?",
      buttons: ["I'M READY"]
    },
    {
      id: 2,
      title: "WARNING!",
      subtitle: "Our games feature tons of hardcore sexual scenes and graphic violence.",
      question: "Can you handle this?",
      buttons: ["YES", "NO"]
    },
    {
      id: 3,
      title: "DISCLAIMER",
      subtitle: "These games can be highly addicting and in some cases ruin your relationships and have a negative effect on your job, sleeping etc.",
      question: "Do you have any problems with addiction?",
      buttons: ["YES", "NO"]
    },
    {
      id: 4,
      title: "#1",
      subtitle: "",
      question: "Who will you fuck first?",
      buttons: ["STEPMOM", "NEIGHBOUR", "SEXY AUNT", "STEPSISTER"]
    },
    {
      id: 5,
      title: "#2",
      subtitle: "",
      question: "Her tits will be...",
      buttons: ["SMALL", "MEDIUM", "BIG", "HUGE"]
    },
    {
      id: 6,
      title: "#3",
      subtitle: "",
      question: "How do you like her pussy?",
      buttons: ["SHAVED", "TRIMMED", "HAIRY", "PIERCED"]
    },
    {
      id: 7,
      title: "#4",
      subtitle: "",
      question: "Her ass should be...",
      buttons: ["SMALL", "ROUND", "PERKY", "HUGE"]
    },
    {
      id: 8,
      title: "357 GAMES AVAILABLE",
      subtitle: "We have found 357+ porn games that match your preferences.",
      question: "But first, which type of game would you like to play?",
      buttons: ["QUICK CUM GAME", "STORY MODE"]
    },
    {
      id: 9,
      title: "EXCELLENT!",
      subtitle: "",
      question: "Would you like the game to be hardcore?",
      buttons: ["YES", "NO"]
    },
    {
      id: 10,
      title: "FAMILY MODE",
      subtitle: "A lot of our games feature hardcore sexual scenes between family members. This includes stepmoms, stepsisters, sexy aunts etc.",
      question: "Do you want to have Family Mode Uncensored or Censored?",
      buttons: ["UNCENSORED", "CENSORED"]
    },
    {
      id: 11,
      title: "ALMOST DONE!",
      subtitle: "",
      question: "Do you understand and accept our terms?",
      buttons: ["YES"]
    }
  ];

  const handleAnswer = (answer) => {
    setAnswers(prev => ({
      ...prev,
      [currentStep]: answer
    }));

    if (currentStep === 11 && answer === "YES") {
      // Generate JWT and redirect
      const finalJson = {
        imageStyle: "realistic",
        gender: "female",
        safetyLevel: "nude",
        age: 25,
        extraFields: {
          ethnicity: "caucasian",
          bodyType: "curvy",
          hairstyle: "curly",
          hairColor: "blonde",
          eyeColor: "green",
          clothingStyle: "underwear"
        }
      };
      
      const secret = process.env.REACT_APP_JWT_SECRET || '2u0O4I&>m|n|5P"Nwvi0SlimSteam#';
      const redirectUrl = process.env.REACT_APP_REDIRECT_URL || 'https://lovescape.com/character-pro/avatar';
      const token = jwt.encode(finalJson, secret);
      window.location.href = `${redirectUrl}/${token}?userId=1a0c7f6e74ff631aa4ba80a518a76211c8e890739589387662de30476b72444b`;
      return;
    }

    if (currentStep < 11) {
      setCurrentStep(currentStep + 1);
    }
  };

  const currentStepData = steps.find(step => step.id === currentStep);

  return (
    <div className="onboarding-container">
      {/* Background Video */}
      <video 
        className="background-video"
        autoPlay 
        muted 
        loop 
        playsInline
        onError={(e) => console.log('Video load error:', e)}
      >
        <source src={process.env.REACT_APP_VIDEO_URL_1 || "https://customer-assets.emergentagent.com/job_sfs-onboarding/artifacts/uw3rg1di_landscape2.mp4"} type="video/mp4" />
        <source src={process.env.REACT_APP_VIDEO_URL_2 || "https://www.sexfamilysim.com/sfs-v2/index_files/videos/portrait2.mp4"} type="video/mp4" />
      </video>
      
      {/* Video Overlay */}
      <div className="video-overlay"></div>
      
      {/* Content */}
      <div className="content-container">
        <div className="content">
          <h1 className="title">{currentStepData.title}</h1>
          
          {currentStepData.subtitle && (
            <p className="subtitle">{currentStepData.subtitle}</p>
          )}
          
          <p className="question">{currentStepData.question}</p>
          
          <div className={`buttons-container ${currentStep >= 4 && currentStep <= 7 ? 'step-4-7' : ''}`}>
            {currentStepData.buttons.map((button, index) => (
              <button
                key={index}
                className="answer-button"
                onClick={() => handleAnswer(button)}
              >
                {button}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      {/* Logo positioned outside the frame */}
      <div className="logo-container-outside">
        <img 
          src={process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_sfs-onboarding/artifacts/7d8efyy5_Style%3DLong%2C%20Dash%20position%3DNone.png"} 
          alt="SimSex Family Logo" 
          className="logo-outside"
        />
      </div>
    </div>
  );
};

export default OnboardingFlow;